import { render, staticRenderFns } from "./ProposalLpjKegiatan.vue?vue&type=template&id=5e6ef2c0"
import script from "./ProposalLpjKegiatan.vue?vue&type=script&lang=js"
export * from "./ProposalLpjKegiatan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports